// SuperUsers,Διαχειριστής ανακοινώσεων,Admin,Ελεγκτής
export default function userParser(role) {
  const groups = localStorage.getItem("usergroups");
  if (groups.includes(role)) {
    return true;
  } else {
    return false;
  }
}
